var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDepartmentIconWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CE17F505-3086-4316-A6D6-7B737F89E099") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-Company---First-Access",
    transform: "translate(-1082.000000, -586.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "department-copy-2",
    transform: "translate(1058.000000, 570.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9829787,0 C5.36496232,0 -1.45132133e-15,5.36496232 -1.45132133e-15,11.9829787 C-1.45132133e-15,18.6009951 5.36496232,23.9659574 11.9829787,23.9659574 C18.6009951,23.9659574 23.9659574,18.6009951 23.9659574,11.9829787 C23.9581538,5.36819739 18.5977601,0.00780364328 11.9829787,0 Z M11.9829787,21.787234 C6.56823803,21.787234 2.1787234,17.3977194 2.1787234,11.9829787 C2.1787234,6.56823803 6.56823803,2.1787234 11.9829787,2.1787234 C17.3977194,2.1787234 21.787234,6.56823803 21.787234,11.9829787 C21.7812304,17.3952307 17.3952307,21.7812304 11.9829787,21.787234 L11.9829787,21.787234 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9829787,3.26808511 C11.3813409,3.26808511 10.893617,3.75580895 10.893617,4.35744681 L10.893617,19.6085106 C10.893617,20.2101485 11.3813409,20.6978723 11.9829787,20.6978723 C16.7960816,20.6978723 20.6978723,16.7960816 20.6978723,11.9829787 C20.6978723,7.16987588 16.7960816,3.26808511 11.9829787,3.26808511 Z M13.0723404,18.4287319 L13.0723404,5.53722553 C16.2199219,6.066277 18.5250962,8.79124493 18.5250962,11.9829787 C18.5250962,15.1747125 16.2199219,17.8996804 13.0723404,18.4287319 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDepartmentIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/departmentIconWhite.83f995ac04fa39a13a6fe7fe36505b80.svg";